module.exports = "table.ThongKeWebSite {\r\n    width: 100%;\r\n    background-color: #FFF; \r\n}\r\n\r\ntable.ThongKeWebSite th {\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\ntable.ThongKeWebSite td {\r\n    padding: 10px !important;\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/dashboard/dashboard.component.css
// module id = ./src/app/admin/dashboard/dashboard.component.css
// module chunks = main